/* eslint-disable */

// Import useEffect
import React, { useState, useEffect } from "react";

// @mui material components
import { Grid, Card, CircularProgress, Divider } from "@mui/material";

// ExcelJS import
import * as excelJS from "exceljs";
import { saveAs } from "file-saver";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// context imports
import { useMaterialUIController, setCurrentStudy } from "context";

// Firebase imports
import { doc, updateDoc, getDoc, getDocs, collection, query, orderBy } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../../Firebase";

// Sort array by date in ascending order
const sortByDateAscending = (array, propName = 'date') => {
  return array.sort((a, b) => {
    const dateA = new Date(a[propName]);
    const dateB = new Date(b[propName]);
    return dateA - dateB;
  });
};

function Directory() {

  const _columns = [
    { Header: "study", accessor: "study", width: "45%", align: "left" },
    { Header: "", accessor: "download", align: "right" },
  ]
  const _rows = []

  const [columns, setColumns] = useState(_columns)
  const [rows, setRows] = useState(_rows)

  const [controller, dispatch] = useMaterialUIController();
  const [directory, setDirectory] = useState([]);
  const [currentStudy, setCurrentStudy] = useState(null);
  const [studies, setStudies] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [studiesNotLoaded, setStudiesNotLoaded] = useState(true);
  const [directoryNotLoaded, setDirectoryNotLoaded] = useState(true);

  // Fetch all studies tied to the current user
  useEffect(() => {
    (async () => {

      const auth = getAuth();
      const userInfo = auth.currentUser;
      const storeUser = userInfo.uid || userInfo.email;

      // Get studies associate with the current user
      const colRef = await getDocs(collection(db, "USERS", storeUser, "STUDIES"));
      const studyDocs = colRef.docs.map((el) => ({ id: el.id, ...el.data() }));
      setStudies(studyDocs);

      // Populate table rows
      const newRows = []
      for (const item of studyDocs){
        newRows.push({
          study: <>{item.id}</>,
          download: (
            <MDButton
              component="button"
              onClick={() => {
                getStudyUserDirectory({ id: item.id })
              }}
              // variant="text"
              color="info"
            >
              Export
            </MDButton>
          ),
        })
      }
      setRows(newRows);

      setStudiesNotLoaded(false);

    })();
  }, []);

  // Fetch all users from Storefront
  const fetchAllUsers = async () => {
    return new Promise(async (resolve, reject) => {
      try {

        const studyDirectory = {};
        const users = [];
        const colRef2 = await getDocs(collection(db, "USERS"));

        const userPromises = colRef2.docs.map(async (el) => {
          const userId = el.id;
          const userData = el.data();
          const userStudies = await getDocs(collection(db, "USERS", userId, "STUDIES"));
          
          const user = {
            id: userId,
            ...userData,
            studies: [],
          };

          // Process all studies for this user
          userStudies.docs.forEach((study) => {
            const studyId = study.id;
            
            if (!studyDirectory[studyId]) {
              studyDirectory[studyId] = [];
            }

            // Add study ID to user's studies
            user.studies.push(studyId);

            // Add user to study directory
            studyDirectory[studyId].push(user);
          });

          return user;
        });

        const allUsers = await Promise.all(userPromises);
        users.push(...allUsers);

        resolve(users);

      } catch (err) {
        reject(err);
      }
    });
  };

  // Fetch users from a study
  const fetchStudyUsers = async (studyName = null) => {
    let users = [];
    if (allUsers.length > 0){
      users = [ ...allUsers ];
    } else {
      users = await fetchAllUsers();
    }
    if (studyName){
      const returnUsers = users.filter(user => user.studies.includes(studyName));
      const uniqueUsers = returnUsers.filter((obj, index, self) =>
        index === self.findIndex((t) => t.email === obj.email)
      );
      return uniqueUsers;
    }
  };

  // Get study user directory
  const getStudyUserDirectory = async (props) => {

    const { id = null } = props;

    const users = await fetchStudyUsers(id); 

    // Exceljs Start
    const workbook = new excelJS.Workbook();
    workbook.creator = "test";
    workbook.lastModifiedBy = "test";
    workbook.created = new Date();
    workbook.modified = new Date();

    const sheet = workbook.addWorksheet(`${id || ''}_USERS`);

    // Styles
    const thinBorder = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    };

    const blueFill = {
      type: "pattern",
      pattern: "darkTrellis",
      fgColor: { argb: "ddebf7" },
      bgColor: { argb: "ddebf7" },
    };

    let headingName = `${(id || '').toUpperCase()} USERS`;

    // Setup heading
    sheet.getRow(1).values = [headingName, "", , " "];
    sheet.getRow(2).values = [
      // "ID",
      "EMAIL",
      "FIRST NAME",
      "LAST NAME",
      "CREATED ON",
      "SIGNED IN",
      // "PROJECT MANAGER",
    ];

    // Setup columns
    sheet.columns = [
      // { key: "id", width: 25 },
      { key: "email", width: 40 },
      { key: "firstName", width: 15 },
      { key: "lastName", width: 15 },
      { key: "createdOn", width: 15 },
      { key: "signedIn", width: 15 },
      // { key: "pm", width: 15 },
    ];

    const sortedUsers = sortByDateAscending(users, 'createdOn');
    const cellData = sortedUsers.filter(user => (
      user?.email ?
      {
        id: user?.id || '',
        email: user?.email || '',
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        pm: user?.pm?.name || '',
        createdOn: user?.createdOn || '',
        signedIn: user?.signedIn || '',
      } : false
    ));

    sheet.addRows(cellData);

    // Merge cells
    sheet.mergeCells(`A1:E1`);
    sheet.mergeCells("F1:G1");
    // sheet.mergeCells("A1:A2");

    // Style rows
    const row = sheet.getRow(1);
    row.eachCell((cell, rowNumber) => {
      sheet.getColumn(rowNumber).alignment = {
        vertical: "bottom",
        horizontal: "left",
      };
      sheet.getColumn(rowNumber).font = { size: 14, family: 2 };
    });

    // Fills
    sheet.getCell("A1").fill = blueFill;
    sheet.getCell("F1").fill = blueFill;
    sheet.getCell("A2").fill = blueFill;
    sheet.getCell("B2").fill = blueFill;
    sheet.getCell("C2").fill = blueFill;
    sheet.getCell("D2").fill = blueFill;
    sheet.getCell("E2").fill = blueFill;
    sheet.getCell("F2").fill = blueFill;
    sheet.getCell("G2").fill = blueFill;

    // Borders
    sheet.getCell("A1").border = thinBorder;
    sheet.getCell("F1").border = thinBorder;
    sheet.getCell("A2").border = thinBorder;
    sheet.getCell("B2").border = thinBorder;
    sheet.getCell("C2").border = thinBorder;
    sheet.getCell("D2").border = thinBorder;
    sheet.getCell("E2").border = thinBorder;
    sheet.getCell("F2").border = thinBorder;
    sheet.getCell("G2").border = thinBorder;
    // Exceljs end

    workbook.xlsx.writeBuffer().then((buffer) => {
      const today = `${new Date().toLocaleDateString()}-${new Date().toTimeString().slice(0,8).replace(/:/g,'')}`;
      const blob = new Blob([buffer], { type: "applicationi/xlsx" });
      saveAs(blob, `${id}_USERS_${today}.xlsx`);
    });

  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6} md={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  User Directory
                </MDTypography>
              </MDBox>
              <DataTable
                table={{ columns, rows }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              />
              {studiesNotLoaded && (
                <MDBox p={5}>
                  <CircularProgress color="inherit" />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Directory;
